"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import React, { FC } from "react";
import { handleRedirection, getFullUrl } from "../../utils/helper";

export interface PreMarketInsightCardDisplay {
  title: string;
  image: string;
  imageAlt: string;
}

interface PreMarketInsightsClientProps {
  label?: string;
  src?: string;
  insightCards: PreMarketInsightCardDisplay[];
  openInNewTab?: boolean | string;
}

const PreMarketInsightsClient: FC<PreMarketInsightsClientProps> = ({
  label,
  src,
  insightCards,
  openInNewTab,
}) => {

  return (
    <>
      <div className="flex flex-nowrap gap-[12px]">
        {insightCards.map((card) => (
          <div
            onClick={() => {
              const hash = `#${card.title.toLowerCase().replaceAll(" ", "-")}`;
              handleRedirection(`${src}${hash}`, undefined, "true");
            }}
            key={card.title}
            className="flex min-w-0 cursor-pointer flex-1 flex-col gap-[12px] rounded-[4px] border border-[#E5E5E5] p-[12px] md:h-[87px] h-[76px] md:min-w-[200px]"
          >
            <div>
              <img
                src={getFullUrl(card.image ?? "") ?? "/placeholder-image.png"}
                alt={card.imageAlt}
                width={32}
                height={32}
                loading="lazy"
                decoding="async"
                className="h-[20px] w-[20px] object-contain md:h-[32px] md:w-[32px]"
              />
            </div>
            <div className="flex items-center justify-between">
              <p className="text-[14px] md:text-[16px] font-[400px] text-[#1a1a1a]">{card.title}</p>
              <span className="flex items-center">
                <i className="icomoon text-[16px] before:font-bold before:content-['\e911']" />
              </span>
            </div>
          </div>
        ))}
      </div>
      <BFLLink openInNewTab={openInNewTab} href={src}>
        <span className="text-link-primary h-[18px] cursor-pointer md:text-[16px] text-[14px] font-[500]">
          {label}
        </span>
      </BFLLink>
    </>
  );
};

export default PreMarketInsightsClient;